import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { Profile } from "../../../shared/types/profile";
import { Sidebars } from "./services/loadsidebar.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  title = "Support Portal";
  currentRole: Profile;
  sidebars = Sidebars;

  constructor(public router: Router, private authenticationService: AuthenticationService) {}

  ngOnInit() {}

  collapseMenu() {
    if ((document.getElementById("container").style.width = "100%")) {
      return (document.getElementById("container").style.width = "40%");
    } else {
      return (document.getElementById("container").style.width = "100%");
    }
  }

  dropdownMA() {
    if (document.getElementById("dropdown").style.display === "none") {
      document.getElementById("dropdown").style.display = "block";
    } else {
      document.getElementById("dropdown").style.display = "none";
    }
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(["/login"]);
  }
}
